export interface PropertyType {
  type: string;
  label: string;
}

export type GetPropertyTypeResponseTO = PropertyType[];

export enum MultiUnitPropertyType {
  APARTHOTEL = 'APARTHOTEL',
  APARTMENT = 'APARTMENT',
  BOUTIQUE_HOTEL = 'BOUTIQUE_HOTEL',
  HOLIDAY_HOME = 'HOLIDAY_HOME',
  HOSTEL = 'HOSTEL',
  HOTEL = 'HOTEL',
  LODGE = 'LODGE',
  LOFT = 'LOFT',
  RESORT = 'RESORT',
  VILLA = 'VILLA',
}
